import React, { FC } from 'react';
import { FormFieldProps } from './types';
import { Text, FormControl, TextFieldSize, TextField } from '@bechtel/gds';
import { Field } from 'formik';

export const FormField: FC<FormFieldProps> = ({ labelName, fieldName, ...props }) => {
  return (
    <FormControl
      label={
        <Text family="graphik" size="300" color="bechtel.blue.800">
          {labelName}
        </Text>
      }
    >
      <Field name={fieldName}>
        {({ field }) => {
          return <TextField size={TextFieldSize.LARGE} {...field} {...props} />;
        }}
      </Field>
    </FormControl>
  );
};
